import ListingVM from './listing-vm';
export default {
  init: function(node){
    var categories_data = JSON.parse($('#grading_policy_presets_json').val());
    ko.applyBindingsWithValidation(new ListingVM(categories_data), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  } 
};
